export const ADOBE_ACCESS_TOKEN_LS_KEY = 'adobe_access_token';

export interface AdobeUserResponse {
  data: {
    id: string;
  };
}

export interface AdobeTokenResponse {
  access_token: string;
}

export const getAdobeAuthUrl = (): string => {
  const currentUrl = globalThis?.location?.href;
  const state = 'Active';
  const scope = 'learner:read';
  const responseType = 'CODE';

  return `https://captivateprime.adobe.com/oauth/o/authorize?client_id=${process.env
    .ADOBE_CLIENT_ID!}&redirect_uri=${currentUrl}&state=${state}&scope=${scope}&response_type=${responseType}`;
};

export const fetchAdobeToken = async (code: string): Promise<AdobeTokenResponse> => {
  const url = 'https://learningmanager.adobe.com/oauth/token';

  const body = new URLSearchParams({
    client_id: process.env.ADOBE_CLIENT_ID!,
    client_secret: process.env.ADOBE_CLIENT_SECRET!,
    code: code,
  });

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: body.toString(),
  });

  if (!response.ok) {
    throw new Error(`Error fetching Adobe token: ${response.status} - ${response.statusText}`);
  }

  const data = await response.json();

  return data;
};

export const getAdobeToken = (): string | null => {
  // Check if we're in a browser environment (SSR-safe)
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return null;
  }

  return localStorage.getItem(ADOBE_ACCESS_TOKEN_LS_KEY);
};

export const fetchAdobeAccountId = async (): Promise<string> => {
  const token = getAdobeToken();

  if (!token) {
    throw new Error('No Adobe access token available');
  }

  const url = 'https://learningmanager.adobe.com/primeapi/v2/user';

  const headers = {
    Accept: 'application/vnd.api+json',
    Authorization: `oauth ${token}`,
  };

  const response = await fetch(url, { method: 'GET', headers });

  if (!response.ok) {
    throw new Error(`Error fetching Adobe user: ${response.status} - ${response.statusText}`);
  }

  const userResponse: AdobeUserResponse = await response.json();

  const userId = userResponse.data.id;
  const accountId = userId.split('_')[0];

  return accountId;
};
